import React, { useState } from 'react';
import Navbar from '../Components/NavBarV2';
import Footer from '../Components/footer';
import NewsForm from '../Components/NewsForm';
import NewsList from '../Components/NewsList';
import ImgenTituloEventos from '../images/imgEventos1.png';
import Evento from '../images/imgEvento.png';
import Evento1 from '../images/evento1.png';
import Evento2 from '../images/evento2.png';
import Evento3 from '../images/evento3.png';
import Evento4 from '../images/evento4.png';
import Icono from '../images/iconoEventos.png';
import Marca1 from '../images/marca1.png';
import Marca2 from '../images/marca2.png';
import Marca3 from '../images/marca3.png';
import Marca4 from '../images/marca4.png';
import Marca5 from '../images/marca5.png';
import Marca6 from '../images/marca6.png';
import LateralIzquierda from '../images/imgLateralIzquierdaEvento.png';
import LateralDerecha from '../images/imgLateralDerechoEvento.png';

import './Reservation.css'


const News = () => {

    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };


    return (
        <div>
            <Navbar />

            <div class="contenedor-principal">

                <img src={LateralIzquierda} alt="Descubre mas eventos" class="lateral-image" />

                <div class="columna-ancha">

                    <div class="elemento-titulo">
                    <h1>Tus Eventos, Mis Eventos</h1>
                    </div>

                    <div class="contenedor">

                        <div class="lado-izquierdo">
                            <p class="texto">Descubre los eventos</p>
                            <p class="texto">que tenemos para ti</p>
                            <p class="texto2">Descubre las novedades que tenemos para ti</p>
                            <button class="btn">Mas Informacion</button>
                        </div>

                        <div class="lado-derecho">
                            <img src={Evento} alt="Descubre mas eventos" class="imagen" />
                        </div>

                    </div>

                    <div class="elemento">
                        
                        <div class="image-section">
                            <button class="btn-rosania">
                                Rosania Business<br></br>Center
                            </button>
                            <button className='btn-mariscal'>
                                Mariscal<br></br>premium offices
                            </button>
                        </div>

                    </div>
                    <br></br><br></br>

                    <div class="elemento3">

                        <div class="image-section">

                            <div class="elemento3">
                                <img src={Evento1} alt="Evento 1" class="evento1-image" />
                            </div>

                            <div class="elemento-detalles">
                                <h3>Evento 1</h3>
                                <div class="eventos-textos-detalles">
                                    <p>4 Albums</p>
                                </div>
                                
                                <a href="#">&gt; See Details</a>
                            </div>

                            <div class="elemento3">
                                <img src={Evento2} alt="Evento 2" class="evento1-image" />
                            </div>

                            <div class="elemento-detalles">
                                <h3>Evento 2</h3>

                                <div class="eventos-textos-detalles">
                                    <p>2 Albums</p>
                                </div>

                                <a href="#">&gt; See Details</a>
                            </div>
                        </div>

                        <div class="image-section">

                            <div class="elemento3">
                                <img src={Evento3} alt="Evento 3" class="evento1-image" />
                            </div>

                            <div class="elemento-detalles">
                                <h3>Evento 3</h3>
                                <div class="eventos-textos-detalles">
                                    <p>4 Albums</p>
                                </div>
                                <a href="#">&gt; See Details</a>
                            </div>

                            <div class="elemento3">
                                <img src={Evento4} alt="Evento 4" class="evento1-image" />
                            </div>

                            <div class="elemento-detalles">
                                <h3>Evento 4</h3>
                                <div class="eventos-textos-detalles">
                                    <p>4 Albums</p>
                                </div>
                                <a href="#">&gt; See Details</a>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="columna-estrecha">

                    <br></br> <br></br> <br></br> <br></br>
                    <div class="image-section">

                        <div class="marcas-detalles">
                            <p>Marcas con las que trabajamos</p>
                        </div>

                        <div>
                            <button class="boton-eventos2">...</button>
                        </div>

                    </div>

                    <div class="image-section2">

                        <div class="elemento2">
                            <img src={Marca1} alt="Evento 1" class="eventos-image" />
                        </div>

                        <div class="elemento4">
                            <p>Keep it simple</p>
                            <div class="eventos-textos-detalles">
                                <p>Alfredo Torres</p>
                            </div>
                        </div>

                        <div class="elemento">
                            <button class="boton-eventos">
                                <img src={Icono} alt="Descubre mas eventos" class="imagen2" />
                            </button>

                        </div>
                    </div>

                    <div class="image-section2">
                        <div class="elemento2">
                            <img src={Marca2} alt="Evento 1" class="eventos-image" />
                        </div>

                        <div class="elemento4">
                            <p>You're wonderful</p>
                            <div class="eventos-textos-detalles">
                                <p>Avery Davis</p>
                            </div>
                        </div>

                        <div class="elemento">
                            <button class="boton-eventos">
                                <img src={Icono} alt="Descubre mas eventos" class="imagen2" />
                            </button>
                        </div>

                    </div>

                    <div class="image-section2">

                        <div class="elemento2">
                            <img src={Marca3} alt="Evento 1" class="eventos-image" />
                        </div>

                        <div class="elemento4">
                            <p>You got this</p>
                            <div class="eventos-textos-detalles">
                                <p>Cahaya Dew</p>
                            </div>
                        </div>

                        <div class="elemento">
                            <button class="boton-eventos">
                                <img src={Icono} alt="Descubre mas eventos" class="imagen2" />
                            </button>
                        </div>
                    </div>
                    <div class="image-section2">

                        <div class="elemento2">
                            <img src={Marca4} alt="Evento 1" class="eventos-image" />
                        </div>

                        <div class="elemento4">
                            <p>Live your purpose</p>
                            <div class="eventos-textos-detalles">
                                <p>Olivia Wilson</p>
                            </div>
                        </div>

                        <div class="elemento">
                            <button class="boton-eventos">
                                <img src={Icono} alt="Descubre mas eventos" class="imagen2" />
                            </button>
                        </div>

                    </div>

                    <div class="image-section2">

                        <div class="elemento2">
                            <img src={Evento2} alt="Evento 1" class="eventos-image" />
                        </div>

                        <div class="elemento4">
                            <p>Kindness</p>
                            <div class="eventos-textos-detalles">
                                <p>Yael Amari</p>
                            </div>
                        </div>

                        <div class="elemento">
                            <button class="boton-eventos">
                                <img src={Icono} alt="Descubre mas eventos" class="imagen2" />
                            </button>
                        </div>
                    </div>

                    <div class="image-section2">

                        <div class="elemento2">
                            <img src={Marca5} alt="Evento 1" class="eventos-image" />
                        </div>

                        <div class="elemento4">
                            <p>Beautiful</p>
                            <div class="eventos-textos-detalles">
                                <p>Juliana Silva</p>
                            </div>
                        </div>

                        <div class="elemento">
                            <button class="boton-eventos">
                                <img src={Icono} alt="Descubre mas eventos" class="imagen2" />
                            </button>
                        </div>

                    </div>

                    <div class="image-section2">

                        <div class="elemento2">
                            <img src={Marca6} alt="Evento 1" class="eventos-image" />
                        </div>

                        <div class="elemento4">
                            <p>Love</p>
                            <div class="eventos-textos-detalles">
                                <p>Itsuki Takahashi</p>
                            </div>
                        </div>

                        <div class="elemento">
                            <button class="boton-eventos">
                                <img src={Icono} alt="Descubre mas eventos" class="imagen2" />
                            </button>
                        </div>
                    </div>
                    <br></br> <br></br> <br></br>
                    <a href="#">Discover All</a>

                </div>
                <div class="imagen-derecha">
                <img src={LateralDerecha} alt="Descubre mas eventos" />
            </div>
            </div>

            

            <div className="container-news">
                <h1>News</h1>
                <button children="btn-publish" onClick={openModal}>Publicar Noticia</button>
                <NewsForm isOpen={isModalOpen} onRequestClose={closeModal} />
                <NewsList />
            </div>
        </div>
        
    );

};


export default News;
